
import React from 'react';
import HelloSign from 'common/utils/hellosign';
import { FormattedMessage } from 'react-intl';
import AccessCode from './access-code';
import SignatureRequest from './signature-request';
import SignatureRequestPreview from './signature-request-preview';
import SignatureRequestConfirm from './signature-request-confirm';
import SignatureRequestComplete from './complete';
import SignatureRequestDeclineComplete from './decline-complete';
import IntlSignatureRequestDelegateComplete from './delegate-complete';
import SignatureRequestAttachment from './signature-request-attachment';
import IntlCompleteQualifiedSignature from './complete-qualified-signature';


const Pages = (props) => {

  const { signatureRequest } = props.location.state;

  switch (props.location.state.contentPage) {
    case 'enterCode':
      return <AccessCode {...props} />;

    case 'signatureRequestPreview':
      return <SignatureRequestPreview {...props} signatureRequest={signatureRequest} />;

    case 'signatureRequestConfirm':
      return <SignatureRequestConfirm {...props} signatureRequest={signatureRequest} />;

    case 'signatureRequest':
      return <SignatureRequest {...props} signatureRequest={signatureRequest} />;

    case 'signatureRequestComplete':
      return <SignatureRequestComplete {...props} signatureRequest={signatureRequest} />;

    case 'completeQualifiedSignature':
      return <IntlCompleteQualifiedSignature {...props} signatureRequest={signatureRequest} />;

    case 'signatureRequestAttachments':
      return <SignatureRequestAttachment {...props} signatureRequest={signatureRequest} />;
    case 'signatureRequestDeclineComplete':
      return <SignatureRequestDeclineComplete {...props} />;

    case 'signatureRequestDelegateComplete':
      return <IntlSignatureRequestDelegateComplete
        {...props}
        headerProps={props.app.login}
        isEmbedded={props.app.isEmbedded()}
        signatureRequest={signatureRequest}
        onXwmSend={props.app.isEmbedded() ? HelloSign.XWM.send : undefined} />;

    default:
      return <div>
        <FormattedMessage
          id='error.notFound.message'
          description="generic error message when the page that is requested is not found"
          defaultMessage="Page not found" />
      </div>;
  }
};

export default Pages;
